import { useTheme } from "@mui/material";
import { ResponsiveBar } from "@nivo/bar";
import { tokens } from "../theme";
import { mockBarData as data } from "../data/mockData";
import { fetchJsonDynamic } from "../data/DynamicServiceNew/jsondynamicservice";
import { userManagementUrl } from "../config";
import { useEffect, useState } from "react";
const baseUrl3 = userManagementUrl.uri;

const BarChart = ({ isDashboard = false, data }) => {
  const theme = useTheme();
  const [LinchartData, setLinchartData] = useState([]);
  const [loading, setLoading] = useState(true);
  const colors = tokens(theme.palette.mode);
  useEffect(() => {
    async function fetchDropdownData() {
      try {
        const linechartinput = data;
        const linechartData = await fetchJsonDynamic(
          "perfomancebarchart",
          "perfomanceBarChart",
          linechartinput,
          baseUrl3
        );
        if (linechartData) {
          setLinchartData(JSON.parse(JSON.parse(linechartData.results)));
        }
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchDropdownData();
  }, []);

  return (
    <>
      {loading ? (
        <div>Loading...</div>
      ) : !LinchartData || LinchartData.length === 0 ? (
        <div>No Data Available for display...</div>
      ): (
        <ResponsiveBar
          data={LinchartData}
          theme={{
            // added
            axis: {
              domain: {
                line: {
                  stroke: colors.grey[100],
                },
              },
              legend: {
                text: {
                  fill: colors.grey[100],
                },
              },
              ticks: {
                line: {
                  stroke: colors.grey[100],
                  strokeWidth: 1,
                },
                text: {
                  fill: colors.grey[100],
                },
              },
            },
            legends: {
              text: {
                fill: colors.grey[100],
              },
            },
          }}
          keys={["checkoffloans", "loanamount", "loancount", "logbookloans"]}
          indexBy="day"
          margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
          padding={0.3}
          valueScale={{ type: "linear" }}
          indexScale={{ type: "band", round: true }}
          colors={{ scheme: "nivo" }}
          defs={[
            {
              id: "dots",
              type: "patternDots",
              background: "inherit",
              color: "#38bcb2",
              size: 4,
              padding: 1,
              stagger: true,
            },
            {
              id: "lines",
              type: "patternLines",
              background: "inherit",
              color: "#eed312",
              rotation: -45,
              lineWidth: 6,
              spacing: 10,
            },
          ]}
          borderColor={{
            from: "color",
            modifiers: [["darker", "1.6"]],
          }}
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: isDashboard ? undefined : "days of the week", // changed
            legendPosition: "middle",
            legendOffset: 32,
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: isDashboard ? undefined : "Counts", // changed
            legendPosition: "middle",
            legendOffset: -40,
          }}
          enableLabel={false}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor={{
            from: "color",
            modifiers: [["darker", 1.6]],
          }}
          legends={[
            {
              dataFrom: "keys",
              anchor: "bottom-right",
              direction: "column",
              justify: false,
              translateX: 120,
              translateY: 0,
              itemsSpacing: 2,
              itemWidth: 100,
              itemHeight: 20,
              itemDirection: "left-to-right",
              itemOpacity: 0.85,
              symbolSize: 20,
              effects: [
                {
                  on: "hover",
                  style: {
                    itemOpacity: 1,
                  },
                },
              ],
            },
          ]}
          role="application"
          barAriaLabel={function (e) {
            return (
              e.id + ": " + e.formattedValue + " in country: " + e.indexValue
            );
          }}
        />
      )}
    </>
  );
};

export default BarChart;
